import React, { useContext, useState, useEffect } from "react";
import { LoanFormContext } from "./LoanForm";
import FormStep from "../../FormStep";
import { Button, Form, InputGroup } from "react-bootstrap";
import NumberFormat from "react-number-format";
import { InputError } from "../Controls";
import validator from "validator";

const ContactNumber: React.FunctionComponent<{
  onSubmit?: (value: string) => void;
}> = (props: { onSubmit?: (value: string) => void }) => {
  const loanFormContext = useContext(LoanFormContext);
  const [number, setNumber] = useState<string>(
    loanFormContext.number ? loanFormContext.number : ""
  );
  const [numberError, setNumberError] = useState<InputError>({
    error: "",
    touched: false,
  });

  useEffect(() => {
    console.log(loanFormContext.loading, "");
  }, []);

  useEffect(() => {
    if (!number.match(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/)) {
      setNumberError({ ...numberError, error: "Please enter a valid number." });
    } else {
      setNumberError({ ...numberError, error: "" });
      loanFormContext.setFormState((state) => ({ ...state, number }));
    }
  }, [number]);

  const handleSubmit = () => {
    if (!numberError.error) {
      if (props.onSubmit) props.onSubmit(number);
    } else {
      setNumberError({ ...numberError, touched: true });
    }
  };

  return (
    <div>
      <FormStep
        header={<h1 className="heading-main">Mobile or home phone number</h1>}
      >
        <div className="form-inputs-wrapper">
          <Form.Group>
            <label>
              <InputGroup className="mb-3">
                <InputGroup.Prepend>
                  <InputGroup.Text id="basic-addon1">
                    <i
                      className="icon-phone"
                      style={{ fontSize: "1.25rem" }}
                    ></i>
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <NumberFormat
                  type="tel"
                  className="form-control"
                  format="(###) ###-####"
                  mask="_"
                  title="tel"
                  value={number}
                  onChange={(e) => {
                    setNumber(e.target.value);
                  }}
                  onBlur={() => {
                    setNumberError({ ...numberError, touched: true });
                  }}
                  tabIndex={0}
                />
              </InputGroup>
            </label>
            {numberError && numberError.touched && (
              <div className="hint text-danger">{numberError.error}</div>
            )}
            <div className="hint">
              (We take privacy seriously, For more information about our privacy
              policy,{" "}
              <a
                href="https://neighborhoodloans.com/privacy-policy/"
                target="_blank"
                rel="noreferrer"
              >
                click here
              </a>
              )
            </div>
          </Form.Group>
          <div className="mt-5">
            <Button
              variant="primary"
              block
              onClick={handleSubmit}
              tabIndex={0}
              disabled={!!loanFormContext.loading}
            >
              Get Pre-Approved
            </Button>
          </div>
        </div>
        <div className="tc">
          <p className="text-center">
            By clicking on the "View My Rates" button above, you consent,
            acknowledge, and agree to our{" "}
            <a
              href="https://neighborhoodloans.com/privacy-policy/"
              target="_blank"
            >
              Privacy Policy
            </a>
            .
          </p>
        </div>
      </FormStep>
    </div>
  );
};

export default ContactNumber;
